import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = {
    key: 0,
    class: "toolbar__icon"
};
const _hoisted_3 = {
    key: 0,
    "aria-hidden": "true",
    focusable: "false"
};
const _hoisted_4 = ["href", "xlink:href"];
const _hoisted_5 = { class: "toolbar__label" };
const _hoisted_6 = ["href", "target", "rel", "download"];
const _hoisted_7 = {
    key: 0,
    class: "toolbar__icon"
};
const _hoisted_8 = {
    key: 0,
    "aria-hidden": "true",
    focusable: "false"
};
const _hoisted_9 = ["href", "xlink:href"];
const _hoisted_10 = { class: "toolbar__label" };
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OutlineButton',
    props: {
        label: {},
        icon: {},
        action: { type: Function },
        disabled: { type: Boolean },
        href: {},
        target: {},
        rel: {}
    },
    setup(__props) {
        const props = __props;
        const iconHref = computed(() => props.icon || '');
        const isSpriteIcon = computed(() => iconHref.value.includes('#'));
        const iconMaskStyle = computed(() => {
            const image = `url('${iconHref.value}')`;
            return {
                maskImage: image,
                WebkitMaskImage: image,
            };
        });
        const isDownloadable = computed(() => {
            if (!props.href)
                return false;
            const url = new URL(props.href, window.location.origin);
            const pathname = url.pathname;
            const ext = pathname.split('.').pop()?.toLowerCase();
            const downloadableExts = ['pdf'];
            return downloadableExts.includes(ext || '');
        });
        return (_ctx, _cache) => {
            return (!__props.href)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "toolbar__outline-btn",
                    type: "button",
                    disabled: __props.disabled,
                    onClick: _cache[0] || (_cache[0] = ($event) => (__props.action?.()))
                }, [
                    (iconHref.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                            (isSpriteIcon.value)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                                    _createElementVNode("use", {
                                        href: iconHref.value,
                                        "xlink:href": iconHref.value
                                    }, null, 8, _hoisted_4)
                                ]))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: "toolbar__icon-glyph",
                                    style: _normalizeStyle(iconMaskStyle.value),
                                    "aria-hidden": "true"
                                }, null, 4))
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(__props.label), 1)
                ], 8, _hoisted_1))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "toolbar__outline-btn",
                    href: __props.href,
                    target: __props.target,
                    rel: __props.rel,
                    download: isDownloadable.value ? '' : undefined
                }, [
                    (iconHref.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            (isSpriteIcon.value)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                                    _createElementVNode("use", {
                                        href: iconHref.value,
                                        "xlink:href": iconHref.value
                                    }, null, 8, _hoisted_9)
                                ]))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: "toolbar__icon-glyph",
                                    style: _normalizeStyle(iconMaskStyle.value),
                                    "aria-hidden": "true"
                                }, null, 4))
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(__props.label), 1)
                ], 8, _hoisted_6));
        };
    }
});
